export default __webpack_public_path__ + "static/media/Groupe 9102.61276440.svg";